export default __webpack_public_path__ + "static/media/tick.037a4312.svg";